import { Box, LinkBox, Text } from "@chakra-ui/react";
import { FC } from "react";
import { Link } from "react-router-dom";
import { BreadCrumb } from "../BreadCrumb/BreadCrumb";

interface GLAMLabHeaderProps {
  paths: { text: string; url: string }[];
}

export const GLAMLabHeader: FC<GLAMLabHeaderProps> = (props) => {
  return (
    <Box
      w="100%"
      h={{ base: "50px", md: "max-content" }}
      pt={{ base: "0px", md: "9px" }}
      pb={{ base: "0px", md: "18px" }}
      display="flex"
      alignItems={{ base: "center", md: "flex-end" }}
      justifyContent="start"
      px="25.7px"
      gap="27px"
      borderBottom={{ base: "none", md: "1px solid #F1F1F1" }}
      bg="#FFFFFF"
      zIndex="0"
    >
      <Text fontSize={{ base: "27px" }}>
        <LinkBox
          as={Link}
          to={window.location.origin + window.location.pathname}
          color="#F26B1C"
          _hover={{ textDecoration: "none", color: "#F26B1C" }}
        >
          GLAMlab
          <span
            style={{
              fontSize: "12px",
              position: "relative",
              top: "-10px",
            }}
          >
            &#174;
          </span>
        </LinkBox>
      </Text>

      <BreadCrumb paths={props.paths} />
    </Box>
  );
};
